module.exports = __webpack_public_path__ + "img/unsplash-logo-alt.de457947.png";